import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import { Button, List, ListItem, ListItemText, IconButton, Grid, Stack, Typography, Tooltip, Divider, CircularProgress } from '@mui/material';
import { makeStyles } from "@mui/styles";
import AttachFile from '@material-ui/icons/AttachFile';
import { getAttachments } from '../../../Store/Ducks/duckTickets';
import { getComments } from '../../../Store/Ducks/duckTicketsComments';
import { handleDownloadAttachment } from '../../../Utils/downloadFiles'

const useStyles = makeStyles((theme) => ({
  list: {
    bgcolor: 'background.paper',
    width: '100%',
    padding: 0
  },
  grid: {
    justifyContent: 'flex-start', alignItems: 'flex-start'
  },
  divider: {
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  text14: {
    fontSize: '14px',
    fontFamily: 'Lato, Arial, sans-serif'
  }
}));

export const TicketCommentsList = ({ ticketNumber, handleClose, supplierTickets }) => {

  const dispatch = useDispatch()
  const classes = useStyles();

  const [currentCommentIndex, setCurrentCommentIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingAtt, setLoadingAtt] = useState(true);

  const comments = useSelector(store => store.ticketsComments?.data?.comments) || []

  useEffect(() => {
    setLoading(true);
    dispatch(getComments(ticketNumber))
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [dispatch, ticketNumber])

  const [att, setAtt] = useState([])

  const attachmentsDetails = (attached_files) => {
    const promises = attached_files.map(idAttachment => dispatch(getAttachments(idAttachment)));
    setLoadingAtt(true);
    Promise.all(promises)
      .then((attachments) => {
        setAtt(attachments);
        setLoadingAtt(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingAtt(false);
      });
  };

  const handleToggleAttachments = (index) => {
    if (currentCommentIndex === index) {
      setCurrentCommentIndex(null);
    } else {
      setCurrentCommentIndex(index);
      attachmentsDetails(comments[index].attached_files);
    }
  }

  return (
    <>
      <Grid container>
        <List className={classes.list}>
          {loading ? (
            <Grid container justifyContent="center" style={{ padding: '10px' }}>
              <CircularProgress />
            </Grid>
          ) :
            comments && Array.isArray(comments) && comments.length > 0 ? comments?.map((comment, index) => {
              const labelId = `list-label-${comment.message}`;
              const reverseIndex = comments.length - index;
              return (
                <>
                  <ListItem key={comment.id} >
                    <Grid item xs={11}>
                      <ListItemText
                        id={labelId}
                        primary={
                          <React.Fragment>
                            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                              <Grid id={3} item xs={10} justifyContent="flex-start" >
                                <Typography className={classes.text14}>{comment.author_name}</Typography>
                              </Grid>

                              <Grid id={3} item xs={2} justifyContent="flex-end" >
                                <Typography className={classes.text14}>{moment(comment.dTcreated_at).utcOffset(0, true).format("YYYY-MM-DD HH:mm")}</Typography>
                              </Grid>

                            </div>
                          </React.Fragment>
                        }
                        primaryTypographyProps={{
                          color: comment.author_id === supplierTickets.invgate_UserID ? 'primary' : "secondary",
                        }}
                        align={"left"}
                        secondary={
                          <React.Fragment>
                            <Typography dangerouslySetInnerHTML={{ __html: comment.message }} className={classes.text14}/>
                            {currentCommentIndex === index && (

                              <Typography
                                className={classes.typography}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                                {loadingAtt ? (
                                  <CircularProgress />
                                ) : att && att.length > 0 && att.map(
                                  attachment => (<div
                                    key={attachment.payload.data.id}>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a href="#" onClick={() => handleDownloadAttachment(attachment.payload.data.url, attachment.payload.data.name)}>
                                      {attachment.payload.data.name}
                                    </a>
                                  </div>)
                                )}
                              </Typography>
                            )}
                          </React.Fragment>
                        }
                      />
                    </Grid>
                    <Grid container xs={1} alignItems="center" justifyContent="center">
                      <Grid item>
                        <span className={classes.text14}>{`#${reverseIndex}`}</span>
                      </Grid>
                      <Grid item>
                        {/* comment.author_id === supplierTickets.invgate_UserID &&  */comment.attached_files.length !== 0 && <ListItem >
                          <Tooltip title="Ver Adjuntos">
                            <IconButton onClick={() => handleToggleAttachments(index)}>
                              <AttachFile />
                            </IconButton>
                          </Tooltip>
                        </ListItem>}
                      </Grid>
                    </Grid>
                  </ListItem>
                  {comments.length > 1 && <Divider variant="middle" sx={{ width: "100%" }} className={classes.divider} />}
                </>
              );
            }) : <p style={{ color: "#009900", fontSize: "17px", textAlign: 'center' }}>
              No existen comentarios para esta consulta. Para crear uno nuevo haga clic en <strong>AÑADIR COMENTARIO</strong>.
            </p>}
        </List>
      </Grid>
    </>
  )
}
